import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77c2d8d6")

_pushScopeId("data-v-77c2d8d6")
const _hoisted_1 = { class: "recipe-detail-view" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "commonRecepiDetailDivider" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "commonRecepiDetailDivider" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "commonRecepiDetailDivider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "recipe-detail-view-bottom-empty-view" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailImageView = _resolveComponent("DetailImageView")
  const _component_DetailVideoView = _resolveComponent("DetailVideoView")
  const _component_DetailMyApplianceView = _resolveComponent("DetailMyApplianceView")
  const _component_DetailTitleView = _resolveComponent("DetailTitleView")
  const _component_DetailIngredientsView = _resolveComponent("DetailIngredientsView")
  const _component_DetailInstructionsView = _resolveComponent("DetailInstructionsView")
  const _component_DetailFooterView = _resolveComponent("DetailFooterView")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_DetailImageView, {
      imageUrl: _ctx.getDetailImage()
    }, null, 8, ["imageUrl"]), [
      [_vShow, !_ctx.isShowVideo()]
    ]),
    _withDirectives(_createVNode(_component_DetailVideoView, {
      imageUrl: _ctx.getDetailImage(),
      videoUrl: _ctx.getVideoUrl(),
      recipeId: _ctx.getRecipeId(),
      recipeType: _ctx.getRecipeType()
    }, null, 8, ["imageUrl", "videoUrl", "recipeId", "recipeType"]), [
      [_vShow, _ctx.isShowVideo()]
    ]),
    _withDirectives(_createVNode(_component_DetailMyApplianceView, {
      class: "detail-my-appliance-view",
      isLogin: _ctx.isLogin,
      onClickMyApplianceLink: _ctx.clickMyApplianceLink
    }, null, 8, ["isLogin", "onClickMyApplianceLink"]), [
      [_vShow, _ctx.isShowMyAppliance()]
    ]),
    _createVNode(_component_DetailTitleView, {
      class: "detail-title-view",
      subTitle: _ctx.getSubTitle(),
      title: _ctx.getTitle(),
      label: _ctx.getLabel(),
      labelColor: _ctx.getLabelColor(),
      labelBackgroundColor: _ctx.getLabelBackgroundColor(),
      applianceCategory: _ctx.getApplianceCategory(),
      applianceCategoryId: _ctx.getApplianceCategoryId(),
      nutrition: _ctx.getNutrition(),
      reactions: _ctx.getReactions(),
      note: _ctx.getTitleNote()
    }, null, 8, ["subTitle", "title", "label", "labelColor", "labelBackgroundColor", "applianceCategory", "applianceCategoryId", "nutrition", "reactions", "note"]),
    _hoisted_2,
    _createVNode(_component_DetailIngredientsView, {
      content: _ctx.getContent(),
      themeList: _ctx.getThemeList(),
      varicationList: _ctx.getVariationList(),
      selectThemeType: _ctx.getSelectThemeType(),
      selectVariationType: _ctx.getSelectVariationType(),
      onClickTheme: _ctx.clickTheme,
      onClickVariation: _ctx.clickVariation
    }, null, 8, ["content", "themeList", "varicationList", "selectThemeType", "selectVariationType", "onClickTheme", "onClickVariation"]),
    _hoisted_3,
    _createVNode("div", _mergeProps({ ref: "instructionsView" }, _ctx.updateDetail), [
      _createVNode(_component_DetailInstructionsView, {
        instructions: _ctx.getInstructions(),
        applianceCategory: _ctx.getApplianceCategory(),
        applianceCategoryId: _ctx.getApplianceCategoryId(),
        applianceData: _ctx.applianceData,
        update: _ctx.updateDetail,
        recipeAttachmenList: _ctx.getRecipeAttatchmentList(),
        attachmentList: _ctx.attachmentList,
        pageScrollTop: _ctx.pageScrollTop,
        onSetInstructionItemPosition: _ctx.setInstructionItemPosition,
        onClickBistroSend: _ctx.clickBistroSend
      }, null, 8, ["instructions", "applianceCategory", "applianceCategoryId", "applianceData", "update", "recipeAttachmenList", "attachmentList", "pageScrollTop", "onSetInstructionItemPosition", "onClickBistroSend"])
    ], 16),
    _createVNode(_component_DetailFooterView, {
      note: _ctx.getFooterNote()
    }, null, 8, ["note"]),
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", {
      class: "recipe-detail-view-bottom-bar-empty-view",
      ref: "emptyView",
      style: { 'padding-bottom': _ctx.getPaddingBottom() }
    }, null, 4)
  ], 512)), [
    [_vShow, _ctx.isShowRecipeDetail()]
  ])
})